// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__26OLH","col":"styles_col__3x1D_"};